import { t } from 'common-translation/tools';

export function getErrorPageContent(code) {
  const ErrorPageContent = {
    default: {
      icon: 'network',
      title: t('Loading Error'),
      desc: t('Failed to load the page. Please check the network status and reload the page, or submit a ticket to report it.'),
    },
    400: {
      icon: 'error-400',
      title: t('Bad Request'),
      desc: t('Your browser sent a request that the server could not understand. You can submit a ticket to report it.'),
    },
    403: {
      icon: 'error-403',
      title: t('Access Forbidden'),
      desc: t('Sorry, you do not have the permission to access on this server. You can submit a ticket to report it.'),
    },
    404: {
      icon: 'error-404',
      title: t('Page Not Found'),
      desc: t('Sorry, the requested URL was not found on the server. Please check the URL or submit a ticket to report it.'),
    },
    500: {
      icon: 'error-500',
      title: t('Server Error'),
      desc: t('Sorry, the server encountered an error. You can submit a ticket to report it.'),
    },
    503: {
      icon: 'error-503',
      title: t('Service Unavailable'),
      desc: t('Sorry, the service is temporarily unavailable due to capacity problems. Please reload the page later or submit a ticket to report it.'),
    },
    504: {
      icon: 'error-504',
      title: t('Gateway Timeout'),
      desc: t('Sorry, the server did not respond in time. You can submit a ticket to report it.'),
    },
  };
  return ErrorPageContent[code] ? ErrorPageContent[code] : ErrorPageContent.default;
}
